module.exports = __webpack_public_path__ + "media/bell.af08b706.mp3";